import { lazyRouteComponent } from "@tanstack/react-router";
import { Microscope } from "lucide-react";

import type { PageDef } from "@/app/registry";

export interface ResearchSearch {
  horizon: 5 | 20 | 60;
  universe: string;
  grade: "all" | "A" | "B";
  /** The signal whose stats are open, e.g. "delivery_spike" or "scan:rs_leaders". */
  signal?: string;
}

export function parseResearchSearch(s: Record<string, unknown>): ResearchSearch {
  const h = Number(s.horizon);
  return {
    horizon: h === 5 || h === 60 ? h : 20,
    universe: typeof s.universe === "string" && /^[a-z0-9_]{1,30}$/.test(s.universe) ? s.universe : "liquid500",
    grade: s.grade === "A" || s.grade === "B" ? s.grade : "all",
    ...(typeof s.signal === "string" && s.signal.length <= 100 ? { signal: s.signal } : {}),
  };
}

export const pages: PageDef[] = [
  {
    path: "/app/research",
    proOnly: true,
    title: "Signal research",
    component: lazyRouteComponent(() => import("./ResearchPage"), "ResearchPage"),
    nav: { label: "Signal research", icon: Microscope, group: "Premium", order: 50 },
    validateSearch: parseResearchSearch,
  },
];
